<template>
  <div class="container">
    <ScanHistory />
  </div>
</template>

<script>
import api from "@/api";
import ScanHistory from "@/components/ScanHistory";

export default {
  components: {
    ScanHistory,
  },
  data() {
    return {
      // isLoading: false,
    };
  },
  created() {},
};
</script>

<style scoped lang="scss"></style>
